/* ============================================================
   Premium Product Gallery — vanilla JS, no dependencies
   - Desktop: thumbnail click -> fade; keyboard arrows; cursor-follow zoom
   - Mobile: native scroll-snap slider; dots sync on scroll; tap dot -> slide
   - Public API: root.goToMedia(index)  (used by variant picker)
   - Theme-editor safe: re-inits on shopify:section:load
   ============================================================ */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';

  function init(root) {
    if (!root || root.__pgInit) return;
    root.__pgInit = true;

    var stage  = root.querySelector('[data-stage]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.pgallery__slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var dots   = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    if (!stage || slides.length === 0) return;

    var current = 0;
    function isMobile() { return window.matchMedia(MOBILE).matches; }

    function paint(i) {
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      thumbs.forEach(function (t, idx) {
        var on = idx === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    }

    function select(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      current = i;
      paint(i);
    }

    // Public API — variant picker calls this
    root.goToMedia = function (i) {
      i = Math.max(0, Math.min(slides.length - 1, i || 0));
      if (isMobile()) {
        var slide = slides[i];
        if (slide) stage.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      select(i);
    };

    /* Desktop: thumbnail click */
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { select(parseInt(t.getAttribute('data-thumb'), 10)); });
    });

    /* Mobile: dot click */
    dots.forEach(function (d) {
      d.addEventListener('click', function () { root.goToMedia(parseInt(d.getAttribute('data-dot'), 10)); });
    });

    /* Mobile: sync active dot while swiping */
    var ticking;
    stage.addEventListener('scroll', function () {
      if (!isMobile()) return;
      if (ticking) cancelAnimationFrame(ticking);
      ticking = requestAnimationFrame(function () {
        var i = Math.round(stage.scrollLeft / stage.clientWidth);
        if (i !== current) select(i);
      });
    }, { passive: true });

    /* Keyboard navigation */
    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { root.goToMedia(current - 1); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { root.goToMedia(current + 1); e.preventDefault(); }
    });

    /* Desktop: cursor-follow zoom */
    slides.forEach(function (s) {
      var img = s.querySelector('.pgallery__img');
      if (!img) return;
      s.addEventListener('mousemove', function (e) {
        if (isMobile()) return;
        var r = s.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
        img.style.transform = 'scale(1.6)';
      });
      s.addEventListener('mouseleave', function () { img.style.transform = ''; });
    });

    select(0);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-product-gallery]').forEach(init);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  /* Theme editor: re-init when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
